import type { FollowUp } from "@sales-ops-amplify/shared";
import { apiGet, apiPost } from "./client";

export async function listFollowups(): Promise<FollowUp[]> {
  const res = await apiGet<{ followups: FollowUp[] }>("/api/followups");
  return res.followups ?? [];
}

export type LogFollowupInput = {
  opportunityId?: string;
  company: string;
  dealName: string;
  appliedDate?: string;
  nextFollowUp?: string;
  cadenceStatus?: string;
  channel?: string;
  leadName?: string;
  leadId?: string;
  accountId?: string;
  notes?: string;
  pinOverride?: string;
};

export async function logFollowup(input: LogFollowupInput): Promise<FollowUp> {
  const res = await apiPost<{ followup: FollowUp }>("/api/followups/log", input);
  return res.followup;
}
